import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const purchases = [{
  name: 'Juan',
  city: 'Córdoba'
}, {
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Carlos',
  city: 'Rosario'
}, {
  name: 'Fernanda',
  city: 'Mendoza'
}, {
  name: 'Diego',
  city: 'Santa Fe'
}, {
  name: 'Sofía',
  city: 'Tucumán'
}, {
  name: 'Martín',
  city: 'La Plata'
}, {
  name: 'Lucía',
  city: 'Mar del Plata'
}, {
  name: 'Joaquín',
  city: 'Salta'
}, {
  name: 'Camila',
  city: 'Neuquén'
}, {
  name: 'Lucas',
  city: 'Bariloche'
}, {
  name: 'Valentina',
  city: 'Tucumán'
}];
const INTERVAL_MS = 30000; // every 30 seconds
const VISIBLE_MS = 5000; // popup visible for 5 seconds
export function PurchasePopup() {
  const [currentPurchase, setCurrentPurchase] = useState<{
    name: string;
    city: string;
  } | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    const showPopup = () => {
      const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
      }, VISIBLE_MS);
    };
    // Show first popup 8s after page load
    const initialTimer = setTimeout(showPopup, 8000);
    // Then every 30 seconds
    const interval = setInterval(showPopup, INTERVAL_MS);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-14">
      {isVisible && currentPurchase && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.25
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl border border-gray-100 p-4 flex items-center gap-3 max-w-[300px]" data-id="element-15">
          <div className="bg-green-100 p-2 rounded-full text-green-600 shrink-0" data-id="element-16">
            <CheckCircle2 size={24} data-id="element-17" />
          </div>
          <div data-id="element-18">
            <p className="text-xs text-gray-500 mb-0.5" data-id="element-19">
              Alguien acaba de comprar
            </p>
            <p className="font-bold text-navy text-sm leading-tight" data-id="element-20">
              {currentPurchase.name} de {currentPurchase.city}
            </p>
            <p className="text-xs text-electric font-semibold mt-1" data-id="element-21">
              Pack Completo EF360
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}